module.exports = __webpack_public_path__ + "static/img/img3.7ed7c8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/img3.jpg
// module id = aN4u
// module chunks = 0